// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICreateSuburbanRealtyRequestSchema {
  /** Строка с адресом **/
  address: string;
  /** Категория (участок/дом) **/
  category: ECategory;
  /** Площадь дома **/
  houseArea?: number;
  /** Состояние подписки на пуш **/
  isNeedPushSubscribe: boolean;
  /** Площадь участка **/
  landArea: number;
  /** Широта **/
  lat?: number;
  /** Долгота **/
  lng?: number;
}
export enum ECategory {
  /** Загородный дом **/
  'HouseSale' = 'houseSale',
  /** Загородный участок **/
  'LandSale' = 'landSale',
}
